// extracted by mini-css-extract-plugin
export default {"big":"WindowSize_big__AXf4n"};